var $e35f8fb6c3f9e97c$exports = {};
$e35f8fb6c3f9e97c$exports = {
    "Clear search": `Borrar b\xfasqueda`
};


export {$e35f8fb6c3f9e97c$exports as default};
//# sourceMappingURL=es-ES.mjs.map
